export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  // The agents service through the Admin UI proxy, prefix kept (GSB-7658): the agent card's test chat
  // The agents service behind this app's own origin (GSB-7658); the container env carries no FE_AGENTS_API_URL, so default it.
  VITE_AGENTS_API_URL: import.meta.env.VITE_AGENTS_API_URL ?? '/agents',
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_RESOURCE_INSTRUCTION: import.meta.env.VITE_RESOURCE_INSTRUCTION,
  VITE_RESOURCE_SUPPORT: import.meta.env.VITE_RESOURCE_SUPPORT,
  VITE_FEATURE_LIGHT_DARK_MODE: import.meta.env.VITE_FEATURE_LIGHT_DARK_MODE,
  VITE_FEATURE_FLAG_SWITCHER: import.meta.env.VITE_FEATURE_FLAG_SWITCHER,
  VITE_FEATURE_SESSION_MANAGEMENT: import.meta.env
    .VITE_FEATURE_SESSION_MANAGEMENT,
  VITE_CLIENT_URL: import.meta.env.VITE_CLIENT_URL,
  VITE_FEATURE_HOUSEHOLD_REDIRECT: import.meta.env
    .VITE_FEATURE_HOUSEHOLD_REDIRECT,
  VITE_SUPPLY_SYSTEM_URL: import.meta.env.VITE_SUPPLY_SYSTEM_URL,
  VITE_SUPPLY_SYSTEM_FINANCE_URL: import.meta.env
    .VITE_SUPPLY_SYSTEM_FINANCE_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  // The «Gasbi AI» chat on ai.<zone> (ADR-0004 of Gasbi.Agents): external MCP servers are connected there, and its
  // /agents/mcp/{id}/callback is the redirect URI an administrator registers at such a server (ADR-0004 §2.10).
  VITE_AGENTS_CHAT_URL: import.meta.env.VITE_AGENTS_CHAT_URL,
};
